import _ from 'lodash';
import validateCreditCards from './validateCreditCards';
import validatePassengers from './validatePassengers';
import validateUserRemarks from './validateUserRemarks';
import validateCheckoutFields from './validateAdditionalCheckoutFields';

const validateCheckoutForms = (trip, passengers, creditCards, states, isBooking, travelAgency,
  tripConfirmation, doIgnoreEmptyPassengerDetailValidation,
  doChargeAgencyPlanningFees, agencyPlanningFees, hasReviewedBookingTripPolicy,
  isRequiredBookedTripPolicyReview, hasReviewedBookedTripPolicy,
  isLoggedIn, doHoldOnlyCruiseAsOption,
  doUseSavedCardForBooking, selectedCardForCheckout, itinerariesToBook,
  doSplitServiceFees, agencyPlanningFeesKeptByAgency, acceptedPaymentCards,
  isBookingReviewManual, noteAirDeskRequest, hasAgreedForDataCollection,
  selectedAdditionalCheckoutFields, userRemarks, chargeableItemOptions, tokenizedData,
  loggedInUserEmail) => {
  const isBookedTripPolicyReviewValidated = !isRequiredBookedTripPolicyReview
    || hasReviewedBookedTripPolicy;
  const isBookingTripPolicyReviewValidated = hasReviewedBookingTripPolicy;
  const isNoteAirDeskValidated = !isBookingReviewManual
    || (noteAirDeskRequest && noteAirDeskRequest.length > 0
      && noteAirDeskRequest.trim().length > 0);
  const isUserRemarksValidated = validateUserRemarks(userRemarks);
  const [
    isPassengersValid,
    newPassengersFormsValidation,
    similarPassengersValidation,
    emptyPassengerDetailValidation,
  ] = validatePassengers(passengers, doHoldOnlyCruiseAsOption, travelAgency,
    tripConfirmation, doIgnoreEmptyPassengerDetailValidation, isLoggedIn,
    loggedInUserEmail, itinerariesToBook, trip);
  const [
    isCreditCardValid,
    creditCardsFormValidations,
    isSavedCardValidated,
  ] = validateCreditCards(trip.isCardAddressRequired, trip.isCardSecurityCodeRequired,
    creditCards, states, isBooking,
    doUseSavedCardForBooking, selectedCardForCheckout, acceptedPaymentCards,
    chargeableItemOptions, tokenizedData);

  let isAgencyPlanningFeesValid = doChargeAgencyPlanningFees ? agencyPlanningFees > 0 : true;
  if (doSplitServiceFees && isAgencyPlanningFeesValid
    && (agencyPlanningFeesKeptByAgency > agencyPlanningFees
      || agencyPlanningFeesKeptByAgency <= 0)) {
    isAgencyPlanningFeesValid = false;
  }
  const invalidAdditionalCheckoutFields = validateCheckoutFields(travelAgency.checkoutFields,
    selectedAdditionalCheckoutFields);
  const isAdditionalCheckoutFieldsValid = _.isEmpty(invalidAdditionalCheckoutFields || {});

  if (!isPassengersValid || !isCreditCardValid || !isAgencyPlanningFeesValid
    || !isAdditionalCheckoutFieldsValid || !_.isEmpty(emptyPassengerDetailValidation || {})
    || !isBookedTripPolicyReviewValidated || !isNoteAirDeskValidated
    || !hasAgreedForDataCollection || !isBookingTripPolicyReviewValidated
    || !isUserRemarksValidated) {
    return [
      false,
      newPassengersFormsValidation,
      creditCardsFormValidations,
      similarPassengersValidation,
      emptyPassengerDetailValidation,
      isBookedTripPolicyReviewValidated,
      isBookingTripPolicyReviewValidated,
      isSavedCardValidated,
      isAgencyPlanningFeesValid,
      invalidAdditionalCheckoutFields,
      isNoteAirDeskValidated,
      hasAgreedForDataCollection,
      isUserRemarksValidated,
    ];
  }
  return [true];
};
export default validateCheckoutForms;
